import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

const GetInitiativeROIList = async (IdeaId) => {
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const accessToken = sessionStorage.getItem("access_token");
  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeROIList`,
      {
        params: { IdeaId }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative ROI list:", error);
    throw new Error("Failed to fetch initiative ROI list");
  }
};

export default GetInitiativeROIList;
